import { Address, Asset } from 'nftx.js';
import { useTranslations } from 'use-intl';
import { Dispatch, ReactNode } from 'react';
import { CreateInventoryPositionDetails, Step } from './types';
import Using from './steps/Using';
import SelectInventory from './steps/SelectInventory';
import InputVToken from './steps/InputVToken';
import { QueryStatus } from '@tanstack/react-query';

export interface CreateInventoryPositionProps {
  assetName: string;
  assetAddress: Address;
  assets: Asset[];
  withinModal?: boolean;
  is1155?: boolean;
  step: Step;
  state: CreateInventoryPositionDetails;
  dispatch: Dispatch<Partial<CreateInventoryPositionDetails>>;
  symbol: string;
  vaultId: string;
  Sidebar: ReactNode;
  maxAmount: bigint;
  onNextStep: () => void;
  status: QueryStatus;
}

export const CreateInventoryPosition = ({
  assetName,
  assetAddress,
  assets,
  withinModal = false,
  is1155,
  step,
  state,
  dispatch,
  symbol,
  vaultId,
  Sidebar,
  maxAmount,
  onNextStep,
  status,
}: CreateInventoryPositionProps) => {
  const t = useTranslations('CreateInventoryPosition');

  if (step === 'using') {
    return (
      <Using
        collection={assetAddress}
        collectionName={assetName}
        symbol={symbol}
        vaultId={vaultId}
        onSubmit={onNextStep}
        dispatch={dispatch}
        Sidebar={Sidebar}
        using={state.using}
      />
    );
  }

  if (step === 'inventory' || state.using === 'nft') {
    return (
      <SelectInventory
        status={status}
        assetName={assetName}
        assets={assets}
        is1155={is1155}
        withinModal={withinModal}
        dispatch={dispatch}
        onSubmit={onNextStep}
        Sidebar={Sidebar}
        items={state.items}
      />
    );
  }

  if (step === 'vtoken' || state.using === 'vtoken') {
    return (
      <InputVToken
        dispatch={dispatch}
        onSubmit={onNextStep}
        Sidebar={Sidebar}
        maxAmount={maxAmount}
        symbol={symbol}
        vaultId={vaultId}
      />
    );
  }

  return null;
};

export default CreateInventoryPosition;
